//return false if no offline settings
module.exports = false;
// {
//     offlineTableSettings: [
//         { name : "table1",  offline: true },
//         { name : "table2",  offline: true },
//         { name : "table3", offline: ["insert"] },
//     ]
// } ;